import React from 'react';
import { Row } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';

import { Column } from './_column';

export const HeaderBar = ({
  background,
  children,
}: React.PropsWithChildren<{ background?: string }>) => {
  const backgroundClass = background
    ? `bg-${background}`
    : 'bg-elm-hyper-hyperlight';

  return (
    <React.Fragment>
      <div className={`HeaderBar ${backgroundClass}`}>
        <Row gutter={24} justify="space-between">
          {children}
        </Row>
      </div>
      <style jsx global>{`
        .HeaderBar {
          height: 72px;
          padding: 12px 24px;
          line-height: 24px;
          color: ${Colors.steelHyperdark} !important;
        }
        .HeaderBar .ant-col + .ant-col {
          border-left: 1px solid ${Colors.steel};
        }
        .State.state {
          font-size: 16px;
        }
      `}</style>
    </React.Fragment>
  );
};

HeaderBar.Column = Column;
